import { useRemoveCenterReportCriteriaInfra } from '@/module/ResearchCenter';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface InfraDeleteButtonProps {
  infraId: Id;
  labId: Id;
}

export function InfraDeleteButton({ labId, infraId }: InfraDeleteButtonProps) {
  const mutation = useRemoveCenterReportCriteriaInfra(labId, infraId);
  const deleteProps = useDelete({ mutation, navigateTo: null });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
